import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Initials, displayName } from "../people/bits";
import { dayLabel, lastText } from "../care/text";

export const ListSheet = ({ list, data, onClose }) => {
  const navigate = useNavigate();
  if (!list) return null;
  const ids = data.lists[list.key] || [];
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-paper max-w-lg max-h-[88dvh] overflow-y-auto" data-testid="overview-list-sheet">
        <DialogTitle className="t-name-lg" data-testid="overview-list-title">{list.title}</DialogTitle>
        <DialogDescription className="t-meta" data-testid="overview-list-count">{ids.length} {ids.length === 1 ? "person" : "people"}</DialogDescription>
        <div className="rule-list border-y border-line">
          {ids.map((id) => {
            const p = data.people[id];
            return (
              <button key={id} onClick={() => navigate(`/people/${id}`)} className="w-full flex items-center gap-4 py-4 text-left group" data-testid={`overview-list-row-${id}`}>
                <Initials p={p} size={44} />
                <span className="flex-1 min-w-0">
                  <span className="block t-name-sm group-hover:text-brand transition-colors">{displayName(p)}</span>
                  {p.why && <span className="block text-sm text-ink-soft truncate">{p.why}</span>}
                  <span className="block text-sm text-ink-faint">{p.follow_up ? `${p.follow_up.reason} · ${dayLabel(p.follow_up.due_on)}` : lastText(p.last_connection)}{p.caregiver ? ` · ${p.caregiver.name}` : " · No caregiver yet"}</span>
                </span>
                <ArrowRight size={18} className="text-ink-faint shrink-0" />
              </button>
            );
          })}
          {!ids.length && <p className="py-4 t-meta">No one right now.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
